import { Link } from "gatsby";
import React from "react";
import { buildImageObj } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import { format, formatDistance, differenceInDays } from "date-fns";


function StoryPreview(props) {
  const link = (props.language === 'en' && '/en/blog/'+props.entity+'/'+props?.slug?.current+'/') || (props.language === 'es' && '/es/blog/'+props.entity+'/'+props?.slug?.current+'/');

  return (
    <Link to={link}>
      <div className="story">
        <div className="top">
          {props.mainImage && props.mainImage.asset && (
            <img
              src={imageUrlFor(buildImageObj(props.mainImage))
                .width(1200)
                .height(Math.floor((1 / 2) * 1200))
                .url()}
              alt={props.mainImage.alt}
              width="auto"
              height="auto"
              loading="lazy"
            />
          )}
        </div>
        <div className="bottom">
          <div className="part01">
            <div className="name-date">
              <span>{props.writer.name}&nbsp;&nbsp;</span><span>
              {differenceInDays(new Date(props.publishedAt), new Date()) > 3
                  ? formatDistance(new Date(props.publishedAt), new Date())
                  : format(new Date(props.publishedAt), "MMMM do yyyy")}
              </span>
            </div>
            <h3 className="title">{props.title}</h3>
          </div>
          <div className="part02">
            <div className="name-date">
              <span>{props.writer.name}&nbsp;&nbsp;</span><span>
              {differenceInDays(new Date(props.publishedAt), new Date()) > 3
                  ? formatDistance(new Date(props.publishedAt), new Date())
                  : format(new Date(props.publishedAt), "MMMM do yyyy")}
              </span>
            </div>
            <p className="subtitle">{props.subtitle}</p>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default StoryPreview;
